import { render, staticRenderFns } from "./InventoryTally.vue?vue&type=template&id=643a6858&scoped=true&"
import script from "./InventoryTally.vue?vue&type=script&lang=js&"
export * from "./InventoryTally.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTally.vue?vue&type=style&index=0&id=643a6858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a6858",
  null
  
)

export default component.exports